document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.collection-btn');
  const productGrid = document.getElementById('product-grid');

  buttons.forEach(button => {
    button.addEventListener('click', async () => {
      const handle = button.dataset.collectionHandle;

      // Highlight active button
      buttons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // Fetch and load products
      const response = await fetch(`/collections/${handle}/products.json`);
      const data = await response.json();

      // Render products dynamically
      productGrid.innerHTML = data.products.map(product => `
        <div class="product-card">
          <a href="${product.url}">
            <img src="${product.images[0]?.src || ''}" alt="${product.title}">
            <h3>${product.title}</h3>
            <p>${(product.price / 100).toFixed(2)} $</p>
          </a>
        </div>
      `).join('');
    });
  });
});
